import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="bulk-delete-quote"
export default class extends Controller {
  connect() {
    console.log("bulk_delete_quote_controller.js connected");
  }

  deleteQuotes() {
    if (!confirm("本当に削除しますか？")) {
      return;
    }

    const quote_ids = [
      ...document.querySelectorAll("input[name*=quote_ids]:checked")
    ].map((checkbox) => checkbox.value);

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/quotes/delete_all";

    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = "delete";
    form.appendChild(methodInput);

    const csrfToken = document.querySelector("meta[name='csrf-token']").content;
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    quote_ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "quote_ids[]";
      input.value = id;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
